<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> {{version}}
    </div>
    {{footer}}
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter',
    data: function () {
      return {
        footer: '',
        version: ''
      }
    },
    created: function () {
      this.footer = this.$config.TEXT.footer
      this.version = this.$config.TEXT.footer_version
    }
  }
</script>




// WEBPACK FOOTER //
// Footer.vue?6ed71e5d